export enum CreatePracticeChartFields {
  ChartTypeNum = 'chartTypeNum',
  ChartName = 'chartName',
}

export enum PracticeChartSortLabelType {
  ChartName = 'chartName',
  LastModifiedAt = 'lastModifiedAt',
}

export type TCreatePracticeChart = {
  [CreatePracticeChartFields.ChartTypeNum]: number;
  [CreatePracticeChartFields.ChartName]: string;
};

export enum PracticeChartTableFormLabel {
  PracticeChartId = '번호',
  ChartType = '차트종류',
  ChartName = '차트명',
  LastModifiedAt = '최종 작성일',
}
